import React, { Component } from 'react'
import OktaAuth from '@okta/okta-auth-js'
import { withOktaAuth } from '@okta/okta-react'
import { OktaConfig } from '../config'
import { Login } from '@sukiai/components'
import { LO_STO, ROUTES } from '../lib'
import loSto from '../config/loSto'
import moment from 'moment'
import { withRouter } from 'react-router-dom'

class LoginContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      username: '',
      password: '',
      loading: false,
      error: false
    }

    const oktaAuthConfig = {
      url: OktaConfig.baseURL,
      issuer: OktaConfig.auth.issuer,
      clientId: OktaConfig.auth.client_id,
      redirectUri: OktaConfig.auth.redirect_uri,
      pkce: false,
      onAuthRequired: OktaConfig.auth.onAuthRequired
    }
    this.oktaAuth = new OktaAuth(oktaAuthConfig)
    this.altaisSSOOktaAuth = new OktaAuth(oktaAuthConfig)
  }

  initializeLoSto = () => {
    loSto.remove(LO_STO.CURRENT_APPT_ID)
    loSto.remove(LO_STO.LAST_OPENED_APPT)
    loSto.remove(LO_STO.CURRENT_PATIENT_ID)
    loSto.set(LO_STO.SCHEDULE_DATE, moment().format())
  }

  onSubmit = e => {
    e.preventDefault()
    this.initializeLoSto()
    this.setState({ loading: true })
    const userCredentials = {
      username: this.state.username,
      password: this.state.password
    }
    const encodedCredentials = window.btoa(JSON.stringify(userCredentials))
    loSto.set(LO_STO.RE_WRITE_TRANSFER_TOKEN, encodedCredentials)
    this.oktaAuth.signIn(userCredentials).then(res => {
      if (res.status === 'SUCCESS') {
        loSto.set(LO_STO.SESSION_ID, res.sessionToken)
        this.oktaAuth.token.getWithRedirect({
          responseType: 'id_token',
          responseMode: 'fragment',
          sessionToken: res.sessionToken,
          scopes: ['openid', 'email', 'profile']
        })
      } else {
        this.setState({
          loading: false,
          error: true
        })
        // Login failed but not because of an invalid username/password
        console.error('Authentication error:', res)
      }
    }).catch(err => {
      this.setState({
        loading: false,
        error: true
      })
      console.error('Login error:', err)
    })
  }

  handleAltaisSSOLogin = e => {
    e.preventDefault()
    this.initializeLoSto()
    this.altaisSSOOktaAuth.token.getWithRedirect({
      idp: OktaConfig.auth.altais_client_id_v2,
      responseType: 'id_token',
      responseMode: 'fragment',
      scopes: ['openid', 'email', 'profile']
    })
  }
  
  onUsernameChange = e => {
    this.setState({
      username: e.target.value
    })
  }

  onPasswordChange = e => {
    this.setState({
      password: e.target.value
    })
  }

  onForgotPassword = () => {
    const { username } = this.state
    const { history } = this.props

    history.push({
      pathname: ROUTES.RESET_PASSWORD,
      state: { username }
    })
  }

  resetError = () => {
    this.setState({
      error: false
    })
  }

  render () {
    return (
      <Login
        handleUsernameChange={this.onUsernameChange}
        handlePasswordChange={this.onPasswordChange}
        handleSubmit={this.onSubmit}
        handleForgotPassword={this.onForgotPassword}
        handleAltaisSSOLogin={this.handleAltaisSSOLogin}
        loading={this.state.loading}
        error={this.state.error}
        resetError={this.resetError}
      />
    )
  }
}

export default withOktaAuth(withRouter(LoginContainer))
